module.exports = __webpack_public_path__ + "img/serve-pic.4b625ef6.jpg";